import { E2NtableHeader } from '@/components/Table';
import { Table, TableBody, TableHead, TableRow } from '@e2n/ui';
import { TagebuchEintragHistorie } from '@/domain/controlling/entities/historie';
import { useTranslation } from 'react-i18next';
import { HistorieTableRow } from './HistorieTableRow';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function Historie({
  tagebuchHistorie,
}: {
  tagebuchHistorie: TagebuchEintragHistorie;
}) {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige } = useTagebuchEinstellungen(standortId);

  return (
    <div className="flex flex-col gap-4">
      <Table>
        <E2NtableHeader className="hover:[&_tr]:bg-transparent">
          <TableRow>
            <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-0">
              {t('domain.controlling.umsatzplanung.table.zeitpunkt')}
            </TableHead>
            <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
              {t('domain.controlling.umsatzplanung.table.wetter')}
            </TableHead>
            {umsatzplanungAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
              <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
                {t('domain.controlling.umsatzplanung.table.umsatzIst')}
              </TableHead>
            )}
            {/* <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
              {t(
                'domain.controlling.umsatzplanung.table.produktivitaetUmsatzIst',
              )}
            </TableHead> */}
            {umsatzplanungAnzeige !== 'UMSATZ_PRODUKTIVITAET' && (
              <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
                {t('domain.controlling.umsatzplanung.table.absatzIst')}
              </TableHead>
            )}
            {/* <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
              {t(
                'domain.controlling.umsatzplanung.table.produktivitaetAbsatzIst',
              )}
            </TableHead> */}
            <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4"></TableHead>
          </TableRow>
        </E2NtableHeader>
        <TableBody className="[&_tr:last-child]:border-b">
          <HistorieTableRow
            tagebuchHistorieData={tagebuchHistorie.historie.current}
            type="current"
          />
          <HistorieTableRow
            tagebuchHistorieData={tagebuchHistorie.historie.prevWeek}
            type="prevWeek"
          />
          <HistorieTableRow
            tagebuchHistorieData={tagebuchHistorie.historie.prevMonth}
            type="prevMonth"
          />
          <HistorieTableRow
            tagebuchHistorieData={tagebuchHistorie.historie.prevYear}
            type="prevYear"
          />
        </TableBody>
      </Table>
      <div className="text-xs text-neutrals-700">
        {t('domain.controlling.umsatzplanung.planung.historieDescription')}
      </div>
    </div>
  );
}
